import { useState } from 'react';

import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';

import useAuthentication from 'application/authentication/useAuthentication';
import Button from 'components/Button/Button';
import Input from 'components/Input/Text/Input';

import './LogInQR.scoped.scss';

interface Props {
  children: React.ReactNode;
  color?: string;
  text: string;
  outlined: string;
  desperate: string;
  onClick: () => void;
}

const randomCode = () => {
  return JSON.stringify(Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000);
};
const LoginQR: React.FC<Props> = () => {
  const { login } = useAuthentication();
  const [emptyCrend] = useState<boolean>(false);
  const [errMssg, setErrMssg] = useState('');
  const [{ studentCode, teacherCode }] = useState(() => {
    return {
      studentCode: randomCode(),
      teacherCode: randomCode(),
    };
  });

  const [code, setCode] = useState('');

  const { t } = useTranslation('login');

  function userLogin() {
    setErrMssg('');
    if (code === teacherCode) {
      login({
        email: process.env.REACT_APP_DEMO_TEACHER_EMAIL,
        password: process.env.REACT_APP_DEMO_PASSWORD,
      });
    } else if (code === studentCode) {
      login({
        email: process.env.REACT_APP_DEMO_STUDENT_EMAIL,
        password: process.env.REACT_APP_DEMO_PASSWORD,
      });
    } else {
      setErrMssg('Wrong code');
    }
  }

  const handleEnterKey = event => {
    if (event.key === 'Enter') {
      userLogin();
    }
  };

  return (
    <div className="page section log-in-page flex">
      <div className="content flex column align-center">
        <div className="title-container">
          <div className="title" style={{ fontWeight: 'bolder' }}>
            {t('Log in')}
          </div>
        </div>

        <div className="vertical-separator" />
        <div>
          <QRCode
            title="Schoolify"
            fgColor="#213960"
            value={`Teacher: ${teacherCode}, Student: ${studentCode}`}
          />
          <Input
            desperate
            placeholder="Code"
            onChange={value => setCode(value)}
            onKeyDown={handleEnterKey}
            type="text"
          />
        </div>
        <div className="down-buttons flex w-100 justify-between ">
          <Button
            onClick={() => userLogin()}
            style={{
              width: '100%',
              minHeight: '45px',
              background: `${emptyCrend ? '#E0FFF1' : '#5CD79E'}`,
              borderRadius: '23px',
              color: `${emptyCrend ? '#5CD79E' : '#E0FFF1'}`,
            }}
          >
            {t('Log in')}
          </Button>
        </div>
        <span className="err-mssg">{errMssg ?? ''}</span>
      </div>
    </div>
  );
};

export default LoginQR;
